<template>
  <div class="logistics-info">
    <navbar title="物流信息" left-text show-home></navbar>
    <div class="logistics-info-wrapper" v-show="logisticsList.length">
      <div
        class="child-order-list"
        v-for="(childOrder, index) in logisticsList"
        :key="index"
      >
        <div class="logistics-info-title van-hairline--bottom">
          <span class="icon"></span>
          <span class="platfrom">{{ childOrder.platform.brand }}</span>
        </div>
        <div class="sku-list">
          <a
            href="javascript:;"
            class="jump-details van-hairline--surround"
            v-for="(sku, index) in childOrder.sku_list"
            :key="index"
            @click="
              jumpDetails(sku.item_id, sku.sku_id, childOrder.platform.name)
            "
          >
            <img
              class="van-hairline--surround"
              v-lazy="sku.sku_img"
              :key="index"
            />
          </a>
        </div>
        <ul class="order-info-intro">
          <li>
            <i>物流公司：</i>
            <p>{{ childOrder.express_company }}</p>
          </li>
          <li>
            <i>物流状态：</i>
            <p>{{ childOrder.status_remark }}</p>
          </li>
          <li>
            <i>运单编号：</i>
            <p>{{ childOrder.express_no }}</p>
          </li>
          <li v-if="childOrder.sub_express_nos.length">
            <i>子运单号：</i>
            <p>
              <span
                v-for="(item, index) in childOrder.sub_express_nos"
                :key="index"
                >{{ item }}</span
              >
            </p>
          </li>
        </ul>
        <p class="tips">
          温馨提示：子物流单详情请复制运单号，点击<a
            href="http://www.kuaidi100.com"
            target="blank"
            >这里</a
          >自行查询
        </p>
        <div class="confirm-receipt">
          <button
            class="look-logistics-details"
            @click="
              lookLogisticsDetails(childOrder.express_no, childOrder.platform)
            "
          >
            物流单详情
          </button>
          <button
            :disabled="childOrder.status == 1"
            @click="
              confirmReceipt(childOrder.child_trade_id, childOrder.express_no)
            "
          >
            {{ receiptText(childOrder.status) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
let flag = false
export default {
  name: 'logisticsInfo',
  components: {
    Navbar
  },
  data () {
    return {
      logisticsList: [],
      confirmFlag: false
      // receiptText: '确认收货'
    }
  },
  computed: {
    receiptText (status) {
      return status => {
        if (status) {
          return '已签收'
        } else {
          return '确认收货'
        }
      }
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getLogisticsDetails().then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    /**
     * 商品详情跳转
     */
    jumpDetails (goodsid, skuid, platform) {
      this.$router.push({
        name: 'productDetails',
        query: { goodsid, skuid, platform }
      })
    },
    lookLogisticsDetails (express, { name }) {
      this.$router.push({ name: 'logisticsDetails', query: { express } })
    },
    /**
     * 确认收货
     */
    async confirmReceipt (tradeid, expid) {
      if (flag) {
        return false
      }
      flag = true
      this.$toast.loading({
        duration: 20000,
        message: '请稍后...'
      })
      const res = await this.$axios.post('api/exp/rec', { tradeid, expid })
      if (res.status === 200) {
        this.$toast.clear()
        flag = false
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('收货成功')
          this.updateView(expid)
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 更新视图
     */
    updateView (expid) {
      this.logisticsList.map(order => {
        if (expid === order.express_no) {
          order.status = 1
          order.status_remark = '已签收'
        }
      })
    },

    /**
     * 获取待收货列表
     */
    async getLogisticsDetails () {
      const res = await this.$axios.get(
        `/api/exp/list/${this.$route.query.orderid}`
      )
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.logisticsList = data
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.logistics-info {
}
.logistics-info-wrapper {
}
.child-order-list {
  padding: 0 0.2rem;
  margin-top: 0.26rem;
  background-color: #fff;
}
.logistics-info-title {
  height: 0.8rem;
  background-color: #fff;
  display: flex;
  align-items: center;
  font-size: @fz28;
  color: #403232;
  .icon {
    width: 0.4rem;
    height: 0.4rem;
    background: url("../assets/img/order-icon.png") center no-repeat;
    background-size: 100%;
    margin-right: 0.2rem;
  }
}
.sku-list {
  padding-top: 0.3rem;
  display: flex;
  flex-wrap: wrap;
  .jump-details {
    display: flex;
    align-items: center;
    margin-right: 0.23rem;
    margin-bottom: 0.3rem;
    box-sizing: border-box;
    &:nth-child(4n) {
      margin-right: 0;
    }
    img {
      width: 1.6rem;
      height: 1.6rem;
      // border: 0.5px solid #D6D6D6;
    }
  }
}
.order-info-intro {
  font-size: @fz28;
  color: #403232;
  padding: 0.25rem 0;
  padding-left: 0.1rem;
  border-top: 0.5px solid #979797;
  border-bottom: 0.5px solid #979797;
  line-height: 1.6;
  li {
    display: flex;
    i {
      width: 1.5rem;
    }
    p {
      width: 5.3rem;
      span {
        display: block;
      }
    }
  }
}
.tips {
  font-size: 0.2rem;
  padding: 0.2rem 0;
  a {
    display: inline;
    color: #3498db;
  }
}
.confirm-receipt {
  padding: 0.33rem 0 0.18rem;
  display: flex;
  justify-content: flex-end;
  button {
    width: 1.7rem;
    height: 0.68rem;
    background-color: #3498db;
    border-radius: 30px;
    font-size: @fz24;
    color: #fff;
    &:disabled {
      background-color: #ccc;
    }
  }
  .look-logistics-details {
    background-color: transparent;
    border: 0.5px solid #979797;
    color: @c80;
    margin-right: 0.3rem;
    box-sizing: border-box;
  }
}
</style>
